'use client';
import { useEffect, useRef, useState } from 'react';
import { matchStyles } from '../match.style';

export const OddsTablePagination = ({ paginationCount, scrollLeft }: {paginationCount: number, scrollLeft: number}) => {
	const [scrollIndex, setScrollIndex] = useState(0);
	const elementRef = useRef<HTMLDivElement | null>(null);
	const [elementWidth, setElementWidth] = useState(0);
	useEffect(() => {
		if (scrollLeft > elementWidth / 2) {
			setScrollIndex(1);
		} else {
			setScrollIndex(0);
		}
	}, [scrollLeft])
	useEffect(() => {
		const updateWidth = () => {
			if (paginationCount < 1) {
				return;
			}
			if (elementRef.current) {
				const width = elementRef.current.offsetWidth;
				setElementWidth(width);
			}
		};
		setTimeout(() => {
			updateWidth();
		}, 1000)

		window.addEventListener('resize', updateWidth);
		return () => {
			window.removeEventListener('resize', updateWidth);
		};
	}, []);
	return (
		<div className={matchStyles.pagination} ref={elementRef}>
			<ul>
				{
					Array.from({ length: paginationCount }).map((_, index) => (
						<li key={index} data-status={index === scrollIndex ? 'is-active' : ''} />
					))
				}
			</ul>
		</div>
	)
}